import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Pages/Header";
import Footer from "./Pages/Footer";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);
    return null;
};

const MainLayout = () => (
    <div className="site-shell">
        <ScrollToTop />
        <Header />
        <main className="site-main">
            <Outlet />
        </main>
        <Footer />
    </div>
);

export default MainLayout;
